export const displayName = (result) => {
  let name = result.lastName || "";
  if (result.lastName && result.firstName) name += (", " + result.firstName)
  if (result.firstName && !result.lastName) name += result.firstName;
  if (!name) name = "Name Not Specified";
  return name;
}
